<!-- 左栏 “2023年度“招拍挂”公开出让计划” 列表组件 -->

<template>
    <div class="list-box">
        <ul class="list">

            <li v-for=" list in res_crjg_list" :key="list.attributes.OBJECTID">
                <!-- 以下命名为拼音首字母简写  详见<list_card>组件  -->
                <list_card 
                    :XH="list.attributes.XH"  
                    :WZ="list.attributes.WZ" 
                    :YTFL="list.attributes.YTFL" 
                    :SSCQ="list.attributes.SSCQ" 
                    :NCRMJ="list.attributes.NCRMJ" 
                    :TDYTHRJL="list.attributes.TDYTHRJL"
                    :OBJECTID="list.attributes.OBJECTID" >
                </list_card>
            </li>

        </ul>
    </div>
</template>
  
<script>
  import left_crjh_list from "./left_crjh_list";
  export default left_crjh_list;
</script>
  

<style scoped>
@import '../styles/left_list.css';
</style>
  


// WEBPACK FOOTER //
// src/components/zwfwmap-phone/left_crjh_list/left_crjh_list.vue